import {useContext, useState} from 'react';
import {apis} from '../services/alm';
import {useToast} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import {AppContext} from '../context/AppProvider';
import {ActionType} from '../assets/constants/constants';

const useLibrarySeeAll = () => {
  const [data, setData] = useState([]);
  const {t} = useTranslation();
  const {toast} = useToast();
  const [bookMarkresponse, setBookMarkresponse] = useState<boolean>(false);
  const {dispatch} = useContext(AppContext);

  const getAllLibraryData = async (id: any) => {
    try {
      const response: any = await apis.fetchAllVideos(id);
      setData(response?.data);
    } catch (error) {
      console.log('error', error);
    }
  };
  const addBookMark = async (id: any) => {
    try {
      dispatch({type: ActionType.SET_LOADING, payload: true});
      await apis.addBookMarkLearningObjects(id);
      dispatch({type: ActionType.SET_LOADING, payload: false});
      setBookMarkresponse(!bookMarkresponse);
      toast({
        description: t('Common.msgBookmarkSuccess'),
        variant: 'success',
      });
    } catch (error) {
      console.log('error', error);
    }
  };
  const deleteBookMark = async (id: any) => {
    try {
      dispatch({type: ActionType.SET_LOADING, payload: true});
      await apis.deleteBookMarkLearningObjects(id);
      dispatch({type: ActionType.SET_LOADING, payload: false});
      setBookMarkresponse(!bookMarkresponse);
      toast({
        description: t('Common.msgBookmarkDeleted'),
        variant: 'success',
      });
    } catch (error) {
      console.log('error', error);
    }
  };
  return {
    getAllLibraryData,
    addBookMark,
    deleteBookMark,
    setBookMarkresponse,
    setData,
    bookMarkresponse,
    data,
  };
};

export default useLibrarySeeAll;
